(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('PrivateController', PrivateController);

    PrivateController.$inject = ['$state', '$translate', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function PrivateController ($state, $translate, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN']);

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        vm.menu = [{
          name: $translate.instant('global.menu.home'),
          action: function (){ $state.go('home'); },
          icon: 'glyphicon glyphicon-home',
          hasChild: false,
          isOpen: false,
          isActive: false,
          isVisible: true
        }, {
          name: $translate.instant('global.menu.entities.main'),
          icon: 'glyphicon glyphicon-th-list',
          action: function () {return; },
          hasChild: true,
          isOpen: false,
          isActive: false,
          isVisible: true,
          childrens: [{
            name: $translate.instant('global.menu.entities.norma'),
            action: function (){ $state.go('norma'); },
            icon: 'glyphicon glyphicon-asterisk',
            isActive: false,
            isVisible: true
          }, {
            name: $translate.instant('global.menu.entities.tipoOrdenamiento'),
            action: function (){ $state.go('tipo-ordenamiento'); },
            icon: 'glyphicon glyphicon-asterisk',
            isActive: false,
            isVisible: true
          }, {
            name: $translate.instant('global.menu.entities.materia'),
            action: function (){ $state.go('materia'); },
            icon: 'glyphicon glyphicon-asterisk',
            isActive: false,
            isVisible: true
          }, {
            name: $translate.instant('global.menu.entities.organo'),
            action: function (){ $state.go('organo'); },
            icon: 'glyphicon glyphicon-asterisk',
            isActive: false,
            isVisible: true
          }, {
            name: $translate.instant('global.menu.entities.documento'),
            action: function (){ $state.go('documento'); },
            icon: 'glyphicon glyphicon-asterisk',
            isActive: false,
            isVisible: true
          }, {
            name: $translate.instant('global.menu.entities.intrumentoRelacionado'),
            action: function (){ $state.go('intrumento-relacionado'); },
            icon: 'glyphicon glyphicon-asterisk',
            isActive: false,
            isVisible: true
          }, {
            name: $translate.instant('global.menu.entities.organoRelevante'),
            action: function (){ $state.go('organo-relevante'); },
            icon: 'glyphicon glyphicon-asterisk',
            isActive: false,
            isVisible: true
          }, {
            name: $translate.instant('global.menu.entities.palabraClave'),
            action: function (){ $state.go('palabra-clave'); },
            icon: 'glyphicon glyphicon-asterisk',
            isActive: false,
            isVisible: true
          }]
        }, {
          name: $translate.instant('global.menu.admin.main'),
          icon: 'glyphicon glyphicon-tower',
          action: function (){ return; },
          hasChild: true,
          isOpen: false,
          isActive: false,
          isVisible: vm.isAdmin,
          childrens: [{
            name: $translate.instant('global.menu.admin.userManagement'),
            action: function (){ $state.go('user-management'); },
            icon: 'glyphicon glyphicon-user',
            isActive: false,
            isVisible: vm.isAdmin
          }, {
            name: $translate.instant('global.menu.admin.metrics'),
            action: function (){ $state.go('jhi-metrics'); },
            icon: 'glyphicon glyphicon-dashboard',
            isActive: false,
            isVisible: vm.isAdmin
          }, {
            name: $translate.instant('global.menu.admin.health'),
            action: function (){ $state.go('jhi-health'); },
            icon: 'glyphicon glyphicon-heart',
            isActive: false,
            isVisible: vm.isAdmin
          }, {
            name: $translate.instant('global.menu.admin.configuration'),
            action: function (){ $state.go('jhi-configuration'); },
            icon: 'glyphicon glyphicon-list-alt',
            isActive: false,
            isVisible: vm.isAdmin
          }, {
            name: $translate.instant('global.menu.admin.audits'),
            action: function (){ $state.go('audits'); },
            icon: 'glyphicon glyphicon-bell',
            isActive: false,
            isVisible: vm.isAdmin
          }, {
            name: $translate.instant('global.menu.admin.logs'),
            action: function (){ $state.go('logs'); },
            icon: 'glyphicon glyphicon-tasks',
            isActive: false,
            isVisible: vm.isAdmin
          }, {
            name: $translate.instant('global.menu.admin.apidocs'),
            action: function (){ $state.go('docs'); },
            icon: 'glyphicon glyphicon-book',
            isActive: false,
            isVisible: vm.swaggerEnabled
          }, {
            name: $translate.instant('global.menu.admin.entity-audit'),
            action: function (){ $state.go('entity-audit'); },
            icon: 'glyphicon glyphicon-list-alt',
            isActive: false,
            isVisible: vm.isAdmin
          }, {
            name: $translate.instant('global.menu.admin.elasticsearch-reindex'),
            action: function (){ $state.go('elasticsearch-reindex'); },
            icon: 'glyphicon glyphicon-refresh',
            isActive: false,
            isVisible: vm.isAdmin
          }]
        },  {
          name: $translate.instant('global.menu.account.main'),
          icon: 'glyphicon glyphicon-user',
          action: function (){ return; },
          hasChild: true,
          isOpen: false,
          isActive: false,
          isVisible: true,
          childrens: [{
            name: $translate.instant('global.menu.account.settings'),
            action: function (){ $state.go('settings'); },
            icon: 'glyphicon glyphicon-wrench',
            isActive: false,
            isVisible: true
          }, {
            name: $translate.instant('global.menu.account.password'),
            action: function (){ $state.go('password'); },
            icon: 'glyphicon glyphicon-lock',
            isActive: false,
            isVisible: true
          }, {
            name: $translate.instant('global.menu.account.logout'),
            action: logout,
            icon: 'glyphicon glyphicon-log-out',
            isActive: false,
            isVisible: true
          }]
        }];

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();
